/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import styled from '@emotion/styled';
import { GridFooterContainer } from '@mui/x-data-grid-pro';

const gridFooterContainerStyles = () => `
  .selection-wrapper,
  .records-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: 1rem;
    margin-right: 1rem;
    margin-left: 1rem;

    p.count-selected,
    p.count-total {
      margin-top: unset;
      margin-bottom: unset;
    }
  }

  .selection-wrapper button.columns-button {
    align-items: center;
    line-height: 0.5rem;
  }

  @media (max-width: 75rem) {
    .selection-wrapper {
      margin-right: unset;

      [data-testid='columns-selector'] {
        min-width: 32px;
      }
    }
    .records-wrapper {
      margin-left: unset;
    }

    .truncate {
      max-width: 9rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media (max-width: 24rem) {
    .selection-wrapper {
      margin-right: unset;

      [data-testid='columns-selector'] {
        min-width: 32px;
      }
    }
    .records-wrapper {
      margin-left: unset;
    }

    .truncate {
      max-width: 6rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const StyledGridFooterContainer = styled(GridFooterContainer)`
  ${gridFooterContainerStyles}
`;
